import React from "react";
import CustomTooltip from "../Tooltip";
import { CheckIcon } from "../Icons";
import CircularLoader from "../CircularLoader";

interface IconButtonProps {
  onClick: () => void;
  tooltipText?: string;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}

const Index: React.FC<IconButtonProps> = ({
  onClick,
  tooltipText,
  className,
  loading,
  disabled,
}) => {
  return (
    <CustomTooltip
      text={tooltipText ?? "Save"}
      className="h-[20px] w-[20px]"
      position="bottom"
    >
      <button
        className={`${className} rounded-md items-center border border-[#E9ECF2] h-[20px] w-[20px] !p-0  group cursor-pointer hover:bg-[#F4F5F7]`}
        onClick={onClick}
        disabled={disabled ?? loading}
      >
        {loading ? (
         <CircularLoader size="sm" />
        ) : (
          <CheckIcon
            size={16}
            color={disabled ?? loading ? "[#F4F5F7]" : "#5A8DF1"}
          />
        )}
      </button>
    </CustomTooltip>
  );
};

export default Index;
